export const adminOrderTrackingColumns = [
  { field: "order_id", label: "Order ID", width: "120px" },
  { field: "customer_name", label: "Customer Name", width: "150px" },
  { field: "pickup_datetime", label: "Pickup Date & Time", width: "180px" },
  { field: "delivery_datetime", label: "Delivery Date & Time", width: "180px" },
  { field: "store_name", label: "Store", width: "150px" },
  { field: "pickup_partner", label: "Pickup Partner", width: "150px" },
  { field: "delivery_partner", label: "Delivery Partner", width: "150px" },
  { field: "status_tag", label: "Status", width: "140px" },
  { field: "order_holder", label: "Order With", width: "140px" },
  { field: "action", label: "Action", width: "80px" },
];
